/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Head from "./head.jsx";
import Header from "./header.jsx";
import "./layout.module.scss";

const Layout = ({ pageTitle, children , headElement, headerElement, footerElement}) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);
  const HeadElement = headElement || <Head pageTitle={pageTitle} />;
  const HeaderElement = headerElement || (
    <Header siteTitle={data.site.siteMetadata.title} />
  );
  const FooterElement = footerElement || (
    <footer>
      © {new Date().getFullYear()}, Built with <a href="https://www.gatsbyjs.org">Gatsby</a>
    </footer>
  );

  return (
    <>
      {HeadElement}
      {HeaderElement}
      <main>{children}</main>
      {FooterElement}
    </>
  );
};

Layout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  headElement: PropTypes.element,
  headerElement: PropTypes.element,
  footerElement: PropTypes.element,
};

export default Layout;
